module.exports = __webpack_public_path__ + "img/dealer-name-marquee-cjdr.c3fb9e32.png";